import React from "react";

const Spinner = () => {
    return <div className="loading-spinner" />;
};

export default Spinner;
